import { useEffect, useState } from "react";
import { api } from "@/api";
import { toast } from "@/lib/toast";
import { Btn, Field, Modal, errMsg } from "../comptabilite/_shared";
import { fmtTs } from "./AuditTable";

const OPTIONS = [["1", "1 an"], ["2", "2 ans"], ["3", "3 ans"], ["5", "5 ans"], ["7", "7 ans (conservation des pièces comptables)"], ["10", "10 ans"], ["", "Illimitée — rien n'est purgé"]];

export default function AuditSettingsModal({ onClose, onChanged, stats }) {
  const [years, setYears] = useState("7");
  const [busy, setBusy] = useState(false);
  const [purging, setPurging] = useState(false);

  useEffect(() => { api.get("/audit/settings").then((r) => setYears(r.data.retention_years ? String(r.data.retention_years) : "")).catch(() => {}); }, []);

  const save = async () => {
    setBusy(true);
    try { await api.put("/audit/settings", { retention_years: years ? Number(years) : null }); toast.success("Durée de conservation enregistrée"); onChanged?.(); onClose(); }
    catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };
  const purge = async () => {
    if (!window.confirm("Supprimer maintenant les entrées plus anciennes que la durée de conservation ?")) return;
    setPurging(true);
    try { const r = await api.post("/audit/purge"); toast.success(`${r.data.deleted} entrée(s) purgée(s)`); onChanged?.(); }
    catch (e) { toast.error(errMsg(e)); }
    finally { setPurging(false); }
  };

  return (
    <Modal title="Conservation de la piste d'audit" sub="Les entrées plus anciennes sont purgées automatiquement chaque nuit à 4 h." onClose={onClose} testId="audit-settings-modal"
      footer={<>
        <Btn tone="danger" onClick={purge} busy={purging} disabled={!years} testId="audit-purge-btn">Purger maintenant</Btn>
        <Btn tone="slate" onClick={onClose} testId="audit-settings-cancel">Annuler</Btn>
        <Btn onClick={save} busy={busy} testId="audit-settings-save">Enregistrer</Btn>
      </>}>
      <Field label="Conserver les entrées pendant">
        <select value={years} onChange={(e) => setYears(e.target.value)} className="border border-slate-300 rounded-lg px-2 py-2 text-sm w-full" data-testid="audit-retention-select">
          {OPTIONS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
      </Field>
      {stats && (
        <p className="text-xs text-slate-500" data-testid="audit-settings-stats">
          {stats.total} entrée{stats.total > 1 ? "s" : ""} au total{stats.oldest ? ` · la plus ancienne : ${fmtTs(stats.oldest)}` : ""}.
        </p>
      )}
    </Modal>
  );
}
